import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { unstable_batchedUpdates } from "react-dom";
import {
  HeaderTable,
  Tabs,
  Input,
  InputNumber,
  PermissionDirect,
  TableActionButtons,
} from "../../Components";
import styles from "./BusinessPlan.module.scss";
import detailTableDisabledStyles from "../../shared/detailTableDisabled.module.scss";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  InputRef,
  Modal,
  Row,
  Table,
  TabsProps,
  message,
  notification,
} from "antd";
import dayjs from "dayjs";
import { buildColumnsWithHeaderFilters } from "../../Components/FilterBar";
import { PlusIcon, Setting } from "../../assets/icon";
import {
  CommonApi,
  RouteManagerApi,
  BusinessPlanApi,
  getPermissionDirections,
  FreightRevenueApi,
} from "../../services";
import { decorateEditableColumns } from "../../shared/helpers/editableColumns";
import { updateColumnDisplayState } from "../../shared/helpers/tableColumns";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import {
  buildCustomerLookupOption,
  buildLookupRequestParams,
  buildRouteBaseLookupOption,
  customerLookupTable,
  getLookupTablePayloadId,
  type LookupFilters,
  routeBaseLookupTable,
} from "../../shared/lookupTables";
import {
  CopyOutlined,
  DeleteOutlined,
  EditFilled,
  SyncOutlined,
} from "@ant-design/icons";
import utils from "../../utils";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";
import {
  applyBusinessPlanInvalidation,
  applyBusinessPlanRouteDetail,
  canDeleteBusinessPlan,
  createBusinessPlanDraft,
  getBusinessPlanPaginationAfterInvalidation,
  hasNullRequiredField,
  mapAllEditableNodesToPayload,
  mergeBusinessPlanRowsWithEdits,
  mergePriorityDeep,
  normalizeTouchedKey,
  releaseBusinessPlanSaveLock,
  resetBusinessPlanPaginationAfterCriteriaChange,
  replaceBusinessPlanRowById,
  setByPath,
  setDeepImmutable,
  shouldApplyBusinessPlanListResponse,
  toPath,
  tryAcquireBusinessPlanSaveLock,
  updateTreeById,
} from "./helpers";
const { getAllRouterBase, getOneRouter } = RouteManagerApi;
const apiDebounceRoute = (
  search: string,
  _value?: string,
  filters: LookupFilters = {},
) => {
  return getAllRouterBase(buildLookupRequestParams(search, filters), {
    silentLoading: true,
  }).then((res: any) => res.data?.map(buildRouteBaseLookupOption) || []);
};
const apiDebounceCustomer = (search: string) => {
  return FreightRevenueApi.getAllCustomer({ searchText: search }).then(
    (res: any) => res.data?.map(buildCustomerLookupOption) || [],
  );
};
const { confirm } = Modal;
const BusinessPlan = () => {
  // Define constant
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const [messageApi, contextHolder] = message.useMessage();
  const [activeTabs, setActiveTabs] = useState("1");
  const [data, setData] = useState<any>([]);
  const [onModalPostion, setOnModalPosition] = useState(false);
  const [dataDetail, setDataDetail] = useState<any>();
  const { isLocked, runLocked } = useRequestLock();
  const detailSaveRequestKey = `business-plan:detail:${dataDetail?._id}:save`;
  const isSavingDetail = isLocked(detailSaveRequestKey);
  const [editIndex, setEditIndex] = useState<any>([]);
  const routeRequestByRowRef = useRef<Record<string, string>>({});
  const routeLoadingRowIdsRef = useRef(new Set<string>());
  const [routeLoadingRowIds, setRouteLoadingRowIds] = useState<string[]>([]);
  const savingRowIdsRef = useRef(new Set<string>());
  const [savingRowIds, setSavingRowIds] = useState<string[]>([]);
  const listRequestIdRef = useRef(0);
  const dataMutationVersionRef = useRef(0);
  const [dataRevision, setDataRevision] = useState(0);
  const [selectedRow, setSelectedRow] = useState<any>([]);
  // const [provines, setProvines] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const isDirty = Boolean(
    checkPermissions("BUSSINESS_PLAN", "edit", features) && dataDetail?.onEdit,
  );
  // const [valueReason, setValueReason] = useState("");
  const typeDelivery = [
    { label: "BẮC - NAM", value: "ROAD" },
    { label: "CẢNG", value: "EXIM" },
    { label: "BIÊN", value: "BORDER" },
    { label: "ĐƯỜNG THUỶ", value: "WATERWAY" },
    { label: "CHUYỂN KHO", value: "TRANSFER" },
  ];
  const businessState = [
    {
      label: "Chờ xác nhận",
      value: "CREATED",
      color: "#0082FB",
    },
    {
      label: "Chờ duyệt cấp 1",
      value: "WAITING_APPROVE_L1",
      color: "#FF6200",
    },
    {
      label: "Chờ duyệt cấp 2",
      value: "WAITING_APPROVE_L2",
      color: "#FF6200",
    },
    { label: "Đang hoạt động", value: "ACTIVE", color: "#00B69B" },
    {
      label: "Từ chối",
      value: "REJECTED",
      color: "#F63535",
    },
    {
      label: "Ngừng hoạt động",
      value: "INACTIVE",
      color: "#F63535",
    },
  ];
  const [direction, setDirection] = useState([]);
  // const direction = [
  //   { label: "HP-DN", value: "HP-DN" },
  //   { label: "HP-SG", value: "HP-SG" },
  //   { label: "SG-DN", value: "SG-DN" },
  //   { label: "SG-HP", value: "SG-HP" },
  //   { label: "DN-SG", value: "DN-SG" },
  //   { label: "DN-HP", value: "DN-HP" },
  // ];
  const typeContainer = [
    { label: "20", value: 20 },
    { label: "40", value: 40 },
    { label: "45", value: 45 },
    { label: "48", value: 48 },
  ];
  //   INVESTMENT
  // DRY_RENTAL
  // SERVICE
  const typeOnwership = [
    { label: "ĐẦU TƯ", value: "INVESTMENT" },
    { label: "THUÊ KHÔ", value: "DRY_RENTAL" },
    { label: "DỊCH VỤ", value: "SERVICE" },
  ];
  const REQUIRED_FIELDS = [
    "customerName",
    "routeBaseCode",
    "validFrom",
    "revenue",
    // "direction",
    "container",
    "numbersOfDriver",
    "ownership",
  ];
  const renderButtonApplySelect = [
    {
      children: "Huỷ",
      onClick: () => {
        setSelectedRow([]);
      },
      danger: true,
      type: "primary",
    },
    {
      children: "Xác nhận",
      onClick: () => {
        setSelectedRow([]);
      },
      type: "primary",
    },
  ];
  const newObj = {
    _id: "",
    code: "",
    routeBaseCode: "",
    customerName: "",
    validFrom: new Date(),
    roadType: "",
    // direction: "",
    container: "",
    receiptAddress: "",
    deliveryAddress: "",
    revenue: 0,
    profit: { plan: 0, contractor: 0 },
    status: "new",
    state: "CREATED",
    lines: [],
  };
  const colsBase = [
    {
      title: "#",
      dataIndex: "_id",
      width: 50,
      fixed: "left",
      hidden: false,
      render: (row: any, record: any, index: number) => index + 1,
    },
    {
      title: "Mã PAKD",
      dataIndex: "code",
      filterDataIndex: "searchText",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "string",
        filterProps: {
          placeholder: "Nhập mã PAKD",
        },
      },
    },
    {
      title: "Khách hàng",
      dataIndex: "customerName",
      filterDataIndex: "customer",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "debounce",
        filterProps: {
          showSearch: true,
          fetchOptions: apiDebounceCustomer,
          placeholder: "Nhập khách hàng",
        },
      },
      editType: "LookupTableSelect",
      editProps: (val: any, record: any, editIndex: any) => {
        return {
          ...customerLookupTable,
          fetchOptions: apiDebounceCustomer,
        };
      },
      colReturn: (row: any) => row?.label ?? row,
    },
    {
      title: "Mã tuyến",
      dataIndex: "routeBaseCode",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "string",
        filterProps: { placeholder: "Nhập mã tuyến" },
      },
      editType: "LookupTableSelect",
      editProps: (val: any, record: any, editIndex: any) => {
        return {
          ...routeBaseLookupTable,
          fetchOptions: apiDebounceRoute,
          onChange: (val: any) => {
            handleOnChangeRouter(val, record._id);
          },
        };
      },
      colReturn: (row: any) => row?.label ?? row,
    },
    {
      title: "Hình thức sở hữu",
      dataIndex: "ownership",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: typeOnwership,
          placeholder: "Nhập Hình thức sở hữu",
        },
      },
      editType: "SelectOption",
      editProps: {
        options: typeOnwership,
      },
      colReturn: (row: any) =>
        typeOnwership.find((ite) => ite.label === row || ite.value === row)
          ?.label,
    },
    {
      title: "Ngày",
      dataIndex: "validFrom",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "dateRange",
        filterProps: {},
      },
      editType: "DatePicker",
      editProps: {
        allowClear: false,
      },
      colReturn: (row: any) => (row ? dayjs(row).format("DD/MM/YYYY") : ""),
    },
    {
      title: "Phân loại",
      dataIndex: "roadType",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: typeDelivery,
          placeholder: "Nhập hình thức vận chuyển",
        },
      },
      render: (row: any) =>
        typeDelivery.find((ite) => ite.label === row || ite.value === row)
          ?.label,
    },
    {
      title: "SL tài xế",
      dataIndex: "numbersOfDriver",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          options: [
            { label: "1", value: 1 },
            { label: "2", value: 2 },
          ],
          placeholder: "Nhập số lượng tài xế",
        },
      },
      editType: "SelectOption",
      editProps: {
        placeholder: "Số lượng tài xế",
        options: [
          { label: "1", value: 1 },
          { label: "2", value: 2 },
        ],
        allowClear: true,
      },
    },
    {
      title: "Chiều hàng",
      dataIndex: "direction",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: direction,
          placeholder: "Nhập chiều hàng",
        },
      },
      editType: "SelectOption",
      editProps: {
        placeholder: "Chiều hàng",
        options: direction,
        allowClear: true,
        disabled: true,
      },
    },
    {
      title: "Cont",
      dataIndex: "container",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          placeholder: "Loại container",
          options: typeContainer,
        },
      },
      editType: "SelectOption",
      editProps: {
        placeholder: "Phân loại",
        options: typeContainer,
        allowClear: true,
      },
    },
    {
      title: "Địa điểm",
      dataIndex: "location",
      children: [
        {
          title: "Điểm nhận",
          dataIndex: "receiptAddress",
          filterDataIndex: "receipt",
          importTitle: "Địa điểm nhận hàng",
          fixed: false,
          hidden: false,
          filterConfig: {
            type: "string",
            filterProps: {
              // showSearch: true,
              // options: provines,
              // optionFilterProp: "label",
              placeholder: "Nhập điểm nhận",
            },
          },
        },
        {
          title: "Điểm trả",
          dataIndex: "deliveryAddress",
          filterDataIndex: "delivery",
          importTitle: "Địa điểm trả hàng",
          fixed: false,
          hidden: false,
          filterConfig: {
            type: "string",
            filterProps: {
              // showSearch: true,
              // options: provines,
              // optionFilterProp: "label",
              placeholder: "Nhập điểm trả",
            },
          },
        },
      ],
    },
    {
      title: "Doanh thu",
      dataIndex: "revenue",
      fixed: "right",
      hidden: false,
      editType: "InputNumber",
      colReturn: (row: any) => (
        <div style={{ fontWeight: "bold" }}>
          {(row?.toLocaleString() ?? 0) + "đ"}
        </div>
      ),
      editProps: {
        formatter: (value: number) =>
          `${value}đ`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        controls: false,
      },
    },
    {
      title: "LN xe nhà",
      dataIndex: ["profit", "plan"],
      fixed: "right",
      hidden: false,
      colReturn: (row: string, record: any) => {
        return (
          <div style={{ fontWeight: "bold" }}>
            {(row?.toLocaleString() ?? 0) + "đ"}
          </div>
        );
      },
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        controls: false,
        disabled: true,
      },
    },
    {
      title: "LN xe thầu",
      dataIndex: ["profit", "contractor"],
      fixed: "right",
      hidden: false,
      colReturn: (row: string) => (
        <div style={{ fontWeight: "bold" }}>
          {(row?.toLocaleString() ?? 0) + "đ"}
        </div>
      ),
      editType: "InputNumber",
      editProps: {
        formatter: (value: number) =>
          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        controls: false,
        disabled: true,
        // value: (row: any, record: any, index: any, editIndex: any) => {
        //   const findRecord =
        //     editIndex.length > 0
        //       ? editIndex
        //           .map((ite: any) => ite.record)
        //           .find((it: any) => it.id === record.id)
        //       : null;
        //   const val = findRecord
        //     ? findRecord.revenue -
        //       findRecord.tree?.reduce(
        //         (acc: number, item: any) =>
        //           item.code === "2"
        //             ? acc
        //             : acc + Number(item.values.contractor.value),
        //         0,
        //       )
        //     : row;
        //   return val;
        // },
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "state",
      fixed: "right",
      hidden: false,
      render: (row: boolean) => {
        const state = businessState.find((ite: any) => ite?.value === row);
        return (
          <div
            title={state?.label}
            style={{ color: state?.color, fontWeight: "bold" }}
          >
            {state?.label}
          </div>
        );
      },
      filterConfig: {
        type: "select",
        filterProps: {
          placeholder: "Trạng thái",
          options: businessState,
        },
      },
    },
  ];
  const [columns, setColumns] = useState<any>(colsBase);
  const columnDetail: any = [
    {
      title: "#",
      dataIndex: "configId",
      // width: 50,
      fixed: "left",
      hidden: true,
      width: `${(1 / 24) * 100}%`,
      // render: (row: any, record: any, index: number) => "",
    },
    {
      title: "Chi phí",
      dataIndex: "name",
      fixed: false,
      hidden: false,
      width: `${(4.5 / 24) * 100}%`,
      render: (row: any, record: any) => (
        <div title={row}>
          {record.code} {row}
        </div>
      ),
    },
    {
      title: "Chi phí PAKD",
      dataIndex: ["values", "plan", "value"],
      fixed: false,
      hidden: false,
      width: `${(3 / 24) * 100}%`,
      render: (row: any, record: any, index: number) => (
        <InputNumber
          value={row}
          onChange={(e: any) => {
            handleOnChangeDetail(
              record.configId,
              ["values", "plan", "value"],
              e,
            );
          }}
          formatter={(value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          disabled={
            !record?.values?.plan?.editable || !(dataDetail.state === "CREATED")
          }
        />
      ),
    },
    {
      title: "Chi phí thực tế",
      dataIndex: ["values", "actual", "value"],
      fixed: false,
      hidden: false,
      width: `${(3 / 24) * 100}%`,
      render: (row: any, record: any, index: number) => (
        <InputNumber
          value={row}
          onChange={(e: any) => {
            handleOnChangeDetail(
              record.configId,
              ["values", "actual", "value"],
              e,
            );
          }}
          formatter={(value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          disabled={
            !record?.values?.actual?.editable ||
            !(dataDetail.state === "CREATED")
          }
        />
      ),
    },
    {
      title: "Chi phí xe thầu",
      dataIndex: ["values", "contractor", "value"],
      fixed: false,
      hidden: false,
      width: `${(3 / 24) * 100}%`,
      render: (row: any, record: any, index: number) => (
        <InputNumber
          value={row}
          onChange={(e: any) => {
            handleOnChangeDetail(
              record.configId,
              ["values", "contractor", "value"],
              e,
            );
          }}
          formatter={(value: number) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          disabled={
            !record?.values?.contractor?.editable ||
            !(dataDetail.state === "CREATED")
          }
        />
      ),
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      fixed: false,
      hidden: false,
      render: (row: any, record: any, index: number) => (
        <Input
          value={row}
          onChange={(e: any) => {
            handleOnChangeDetail(record.configId, "note", e);
          }}
          disabled={dataDetail?.ma_pakd || !(dataDetail.state === "CREATED")}
        />
      ),
    },
  ];
  const [filters, setFilters] = useState<any>({});
  const handleBusinessPlanFiltersChange = useCallback((nextFilters: any) => {
    unstable_batchedUpdates(() => {
      setPagination((prev) =>
        resetBusinessPlanPaginationAfterCriteriaChange(prev),
      );
      setFilters(nextFilters);
    });
  }, []);
  const handleBusinessPlanTabChange = useCallback(
    (tab: string) => {
      setActiveTabs(tab);
      handleBusinessPlanFiltersChange((prev: any) => ({
        ...prev,
        state: tab !== "1" && tab !== "6" ? tab : undefined,
      }));
    },
    [handleBusinessPlanFiltersChange],
  );
  const renderColumns = buildColumnsWithHeaderFilters(
    [
      ...decorateEditableColumns(columns, {
        editIndex,
        getDataSource: () => dataSource,
        onUpdate: (dataIndex, value, rowId) =>
          handleUpdateRow(dataIndex, value, rowId),
      }),
      {
        title: "",
        key: "action",
        width: 108,
        fixed: "right",
        render: (_: any, record: any) =>
          editIndex.find((ind: any) => ind.index === record._id) ? (
            <div>
              <Button
                disabled={
                  routeLoadingRowIds.includes(String(record._id)) ||
                  savingRowIds.includes(String(record._id))
                }
                loading={savingRowIds.includes(String(record._id))}
                onClick={() => {
                  handleActionSave(record._id);
                }}
              >
                Lưu
              </Button>{" "}
              <Button
                disabled={
                  routeLoadingRowIds.includes(String(record._id)) ||
                  savingRowIds.includes(String(record._id))
                }
                onClick={() => {
                  handleActionCancel(record._id);
                }}
              >
                Hủy
              </Button>
            </div>
          ) : (
            <TableActionButtons
              items={[
                {
                  key: "edit",
                  label: "Chỉnh sửa",
                  icon: <EditFilled />,
                  tone: "edit",
                  disabled: !checkPermissions(
                    "BUSSINESS_PLAN",
                    "edit",
                    features,
                  ),
                  onClick: () => handleActionTable("edit", record, record._id),
                },
                {
                  key: "copy",
                  label: "Sao chép",
                  icon: <CopyOutlined />,
                  tone: "info",
                  disabled:
                    String(record._id).startsWith("create-") ||
                    !checkPermissions("BUSSINESS_PLAN", "add", features),
                  onClick: () => handleActionTable("copy", record, record._id),
                },
                {
                  key: "delete",
                  label: "Xoá",
                  icon: <DeleteOutlined />,
                  tone: "delete",
                  danger: true,
                  disabled: !canDeleteBusinessPlan(
                    record.state,
                    checkPermissions("BUSSINESS_PLAN", "delete", features),
                  ),
                  onClick: () =>
                    handleActionTable("delete", record, record._id),
                },
              ]}
            />
          ),
      },
    ],
    filters,
    handleBusinessPlanFiltersChange,
  );
  const filterData = (query: string) => {
    if (query === "6") {
      return editIndex.map((ite: any) => ({
        ...ite.record,
        key: ite.record.id,
      }));
    }
    return mergeBusinessPlanRowsWithEdits(data, editIndex);
  };
  const dataSource = useMemo(() => {
    return filterData(activeTabs);
  }, [filters, activeTabs, data, editIndex]);
  const markBusinessPlanDataMutation = () => {
    dataMutationVersionRef.current += 1;
    setDataRevision((prev) => prev + 1);
  };
  // Function to handle action
  const handleUpdateStateSheetCost = async (
    id: string,
    type:
      | "submit"
      | "request-edit"
      | "approve-l1"
      | "approve-l2"
      | "reject"
      | "invalid",
    reason?: string,
  ) => {
    try {
      const response = await BusinessPlanApi.putStateBussinessPlanCostSheet(
        id,
        type,
        { reason },
      );
      if (response) {
        markBusinessPlanDataMutation();
        setData((prev: any[]) =>
          prev.map((item) => (item._id === id ? response : item)),
        );
        setDataDetail((prev: any) =>
          prev?._id === id
            ? { ...prev, ...response, state: response.state }
            : prev,
        );
      }
      return response;
    } catch (error) {
      messageApi.error("Lỗi");
      return null;
    }
  };
  const handleLoadingCaculator = async () => {
    if (!checkPermissions("BUSSINESS_PLAN", "edit", features)) return;

    try {
      const payload = mapAllEditableNodesToPayload(
        dataDetail.lines,
        ["plan", "actual", "contractor"],
        true,
      );
      const response =
        await BusinessPlanApi.patchUpdateBussinessPlanCostSheetPreview(
          payload.changes,
          dataDetail._id,
        );
      const newDataDetail = {
        ...response,
        _id: dataDetail._id,
        state: dataDetail.state,
        onEdit: true,
      };
      setDataDetail(newDataDetail);
    } catch (error) {
      notification.error({ message: "Cập nhật thất bại" });
    }
  };
  const handleSaveDetail = async (): Promise<boolean> => {
    if (isLocked(detailSaveRequestKey)) return false;

    const saved = await runLocked(detailSaveRequestKey, async () => {
      try {
        const payload = mapAllEditableNodesToPayload(
          dataDetail.lines,
          ["plan", "actual", "contractor"],
          true,
        );
        const response =
          await BusinessPlanApi.patchUpdateBussinessPlanCostSheet(
            payload.changes,
            dataDetail._id,
          );
        const newDataDetail = {
          _id: dataDetail._id,
          state: dataDetail.state,
          onEdit: false,
          ...response,
        };
        setDataDetail(newDataDetail);
        return true;
      } catch (error) {
        notification.error({ message: "Cập nhật thất bại" });
        return false;
      }
    });

    return Boolean(saved);
  };
  const handleCancelDetail = () => {
    if (isLocked(detailSaveRequestKey)) return;
    setDataDetail(null);
  };
  const handleOnChangeRouter = async (router: any, id: string) => {
    const rowId = String(id);
    const routeId = getLookupTablePayloadId(router);
    routeRequestByRowRef.current[rowId] = String(routeId ?? "");

    if (!routeId) return;

    routeLoadingRowIdsRef.current.add(rowId);
    setRouteLoadingRowIds((prev) =>
      prev.includes(rowId) ? prev : [...prev, rowId],
    );

    try {
      const detailRouter = await getOneRouter(routeId);
      if (routeRequestByRowRef.current[rowId] !== String(routeId)) return;

      setEditIndex((prev: any[]) =>
        prev.map((item) =>
          String(item.index) === rowId
            ? {
                ...item,
                record: applyBusinessPlanRouteDetail(
                  item.record,
                  router,
                  detailRouter.data,
                ),
              }
          : item,
        ),
      );
    } catch (error) {
      messageApi.error("Không thể tải thông tin mã tuyến");
    } finally {
      if (routeRequestByRowRef.current[rowId] === String(routeId)) {
        routeLoadingRowIdsRef.current.delete(rowId);
        setRouteLoadingRowIds((prev) => prev.filter((item) => item !== rowId));
      }
    }
  };
  const handleActionTable = (action: string, record: any, index: number) => {
    switch (action) {
      case "detail":
        handleOnEditDetail(record._id, record.state);
        break;
      case "edit":
        setEditIndex([...editIndex, { index: index, record: { ...record } }]);
        break;
      case "copy": {
        const temporaryId = `create-${Date.now()}`;
        const draft = createBusinessPlanDraft(record, temporaryId);
        setEditIndex((prev: any[]) => [
          ...prev,
          { index: temporaryId, record: draft },
        ]);
        break;
      }
      case "delete":
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn vô hiệu PAKD này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          onOk: async () => {
            const response = await handleUpdateStateSheetCost(
              record._id,
              "invalid",
            );
            if (!response) {
              throw new Error("BUSINESS_PLAN_INVALIDATION_FAILED");
            }

            setData((prev: any[]) =>
              applyBusinessPlanInvalidation(
                prev,
                record._id,
                response,
                activeTabs,
              ),
            );
            setPagination((prev) =>
              getBusinessPlanPaginationAfterInvalidation(
                prev,
                activeTabs,
                data.length,
              ),
            );
            // // đồng thời xoá khỏi editIndex nếu đang edit
            setEditIndex((prev: any[]) =>
              prev.filter((item) => item.index !== index),
            );
            setDataDetail((prev: any) =>
              prev?._id === record._id ? undefined : prev,
            );
          },
          onCancel() {},
        });
        // tìm index trong data theo id
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleActionSave = async (index: any) => {
    const rowId = String(index);
    if (routeLoadingRowIdsRef.current.has(rowId)) {
      messageApi.warning("Vui lòng chờ tải thông tin mã tuyến");
      return;
    }
    if (!tryAcquireBusinessPlanSaveLock(savingRowIdsRef.current, rowId)) return;
    setSavingRowIds((prev) => [...prev, rowId]);

    try {
      const rowEdit = editIndex.find((ind: any) => ind.index === index)?.record;
      if (!rowEdit) {
        messageApi.error("Không tìm thấy dữ liệu cần lưu");
        return;
      }
      // ✅ check NULL các field req
      if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS)) {
        messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
        return;
      }
      const isNew = rowEdit.status === "new";
      // payload đúng shape API
      const payloadBase = {
        routeBase: getLookupTablePayloadId(
          rowEdit.routeBaseCode,
          rowEdit.routeBase,
        ),
        container: Number(rowEdit.container),
        // direction: rowEdit.direction,
        numberOfDriver: Number(rowEdit.numbersOfDriver),
        customer: rowEdit.customerName?.value ?? rowEdit.customer,
        validFrom: rowEdit.validFrom,
        revenue: Number(rowEdit.revenue),
        ownership: typeOnwership.find(
          (ite) =>
            ite.label === rowEdit.ownership || ite.value === rowEdit.ownership,
        )?.value,
      };
      // ===== CALL API =====
      if (isNew) {
        const res = await BusinessPlanApi.postAddBussinessPlan({
          ...payloadBase,
        });
        // ===== CHỈ KHI API OK =====
        if (res) {
          const draftValues = { ...rowEdit };
          delete draftValues.status;
          const savedRow = {
            ...mergePriorityDeep(draftValues, res),
            _id: res._id,
          };
          markBusinessPlanDataMutation();
          setData((prev: any[]) =>
            replaceBusinessPlanRowById(prev, index, savedRow),
          );
          setEditIndex((prev: any[]) =>
            prev.filter((ind: any) => ind.index !== index),
          );
        }
      } else {
        await BusinessPlanApi.putUpdateBussinessPlan(payloadBase, rowEdit._id);
        markBusinessPlanDataMutation();
        setData((prev: any[]) =>
          replaceBusinessPlanRowById(prev, index, { ...rowEdit }),
        );
        setEditIndex((prev: any[]) =>
          prev.filter((ind: any) => ind.index !== index),
        );
      }
      // // ===== CHỈ KHI API OK =====
    } catch (err: any) {
      messageApi.error(err?.message || "Lưu thất bại");
    } finally {
      releaseBusinessPlanSaveLock(savingRowIdsRef.current, rowId);
      setSavingRowIds((prev) => prev.filter((id) => id !== rowId));
    }
  };
  const handleActionCancel = (index: any) => {
    const rowId = String(index);
    if (savingRowIdsRef.current.has(rowId)) return;
    routeRequestByRowRef.current[rowId] = "";
    routeLoadingRowIdsRef.current.delete(rowId);
    setRouteLoadingRowIds((prev) => prev.filter((item) => item !== rowId));
    setEditIndex((prev: any[]) =>
      prev.filter((ind: any) => ind.index !== index),
    );
  };
  const handleOnEditDetail = async (id: string, state: string) => {
    if (isLocked(detailSaveRequestKey)) return;
    const getNewDetail = async () => {
      await BusinessPlanApi.getDetailBussinessPlan(id)
        .then((res: any) => {
          const newDataDetail = {
            _id: id,
            state: state,
            onEdit: false,
            ...res,
          };
          setDataDetail(newDataDetail);
        })
        .catch((err) => {
          // console.log(err);
          // messageApi.error(
          //   err?.message || "Lấy chi tiết phương án kinh doanh lỗi",
          // );
        });
    };
    checkPermissions("BUSSINESS_PLAN", "edit", features) && isDirty
      ? await confirm({
          title: "Bạn có thay đổi chưa lưu",
          content: "Nếu không lưu dữ liệu sẽ mất khi thay đổi",
          okText: "Lưu",
          cancelText: "Ở lại",
          onOk: async () => {
            await handleSaveDetail();
            await getNewDetail();
          },
        })
      : getNewDetail();
  };
  const handleUpdateRow = (
    key: string,
    value: string,
    index: string | number,
  ) => {
    setEditIndex((prev: any[]) => {
      const newEdit = [...prev];
      const findInd = newEdit.findIndex((item: any) => item.index === index);
      if (findInd === -1) return prev;
      const row = { ...newEdit[findInd] };
      const record = { ...(row.record || {}) };
      const path = toPath(key);
      const touchedKey = normalizeTouchedKey(key);
      // ✅ set nested field
      row.record = setDeepImmutable(record, path, value);
      // ✅ đánh dấu touched
      row.touchedFields = { ...(row.touchedFields || {}), [touchedKey]: true };
      newEdit[findInd] = row;
      return newEdit;
    });
  };
  const handleOnChangeDetail = (
    configId: string | number,
    dataIndex: string | (string | number)[],
    value: any,
  ) => {
    const path = Array.isArray(dataIndex) ? dataIndex : [dataIndex];
    setDataDetail((prev: any) => {
      if (!prev) return prev;
      // 1) tạo bản mới (immutably)
      const newDataDetail = {
        ...prev,
        lines: updateTreeById(prev.lines ?? [], configId, (node) => {
          return setByPath(node, path, value);
        }),
        onEdit: true,
      };
      // 2) đồng bộ listDetailEdit (nếu bạn có state này)
      // setListDetailEdit((old: any[]) => {
      //   // tuỳ bạn dùng key nào để nhận diện 1 detail
      //   // ví dụ: _id
      //   return upsertByKey(old ?? [], newDataDetail, (x) => x._id);
      // });
      // 3) return để cập nhật dataDetail
      return newDataDetail;
    });
  };
  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setColumns(updateColumnDisplayState(columns, dataIndex, value, type));
  };
  const handleAddRow = () => {
    const newAddObj = { ...newObj, _id: `create-${new Date()}` };
    // setDataDetail({ ...rawDataDetail, _id: `create-${new Date()}` });
    setEditIndex((prev: any[]) => [
      ...prev,
      { index: newAddObj._id, record: newAddObj },
    ]);
  };
  const rowSelected = {
    selectedRowKeys: selectedRow,
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      setSelectedRow(selectedRowKeys);
    },
  };
  // Function to render
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Tất cả",
    },
    {
      key: "CREATED",
      label: (
        <span>
          <span>
            Chờ xác nhận{" "}
            {/* <Badge
              count={filterData("2")?.length ?? 0}
              size="small"
              style={{ marginLeft: 8 }}
            /> */}
          </span>
        </span>
      ),
    },
    {
      key: "WAITING_APPROVE_L1",
      label: (
        <span>
          <span>
            Duyệt cấp 1{" "}
            {/* <Badge
              count={filterData("2")?.length ?? 0}
              size="small"
              style={{ marginLeft: 8 }}
            /> */}
          </span>
        </span>
      ),
    },
    {
      key: "WAITING_APPROVE_L2",
      label: (
        <span>
          <span>
            Duyệt cấp 2{" "}
            {/* <Badge
              count={filterData("3")?.length ?? 0}
              size="small"
              style={{ marginLeft: 8 }}
            /> */}
          </span>
        </span>
      ),
    },
    {
      key: "ACTIVE",
      label: "Đang hoạt động",
    },
    {
      key: "INACTIVE",
      label: "Ngưng hoạt động",
    },
    {
      key: "REJECTED",
      label: "Từ chối",
    },
    // {
    //   key: "6",
    //   label: (
    //     <span>
    //       <span>
    //         Đang chỉnh sửa{" "}
    //         <Badge
    //           count={filterData("6")?.length ?? 0}
    //           size="small"
    //           style={{ marginLeft: 8 }}
    //         />
    //       </span>
    //     </span>
    //   ),
    // },
  ];
  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          className: styles.ModalBody,
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định(trái, phải)</Col>
        </Row>
        <Divider />
        {columns?.map((col: any, key: number) => {
          return (
            <div key={key}>
              <Row>
                <Col span={16}>{col.title}</Col>
                <Col span={4}>
                  <Checkbox
                    checked={!col.hidden}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked,
                        "hidden",
                      );
                    }}
                  />
                </Col>
                <Col span={4}>
                  <Checkbox
                    checked={col.fixed === "left" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "left",
                        "fixed",
                      );
                    }}
                    style={{ marginRight: "20px" }}
                  />
                  <Checkbox
                    checked={col.fixed === "right" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "right",
                        "fixed",
                      );
                    }}
                  />
                </Col>
              </Row>
              <Divider />
            </div>
          );
        })}
      </Modal>
    );
  };
  const renderFooterTableDetail = () => {
    const totals = dataDetail.totals;
    const totalCost = totals?.totalCost;
    const profit = totals?.profit;
    return (
      <div>
        <Row>
          <Col span={15}>
            <Row>
              <Col span={9} style={{ fontWeight: "bold" }}>
                Tổng chi phí:
              </Col>
              <Col span={5} style={{ fontWeight: "bold" }}>
                {(totalCost.plan.toLocaleString() ?? 0) + "đ"}
              </Col>
              <Col span={5} style={{ fontWeight: "bold" }}>
                {(totalCost.actual.toLocaleString() ?? 0) + "đ"}
              </Col>
              <Col span={5} style={{ fontWeight: "bold" }}>
                {(totalCost.contractor.toLocaleString() ?? 0) + "đ"}
              </Col>
            </Row>
            <Row>
              <Col span={9} style={{ fontWeight: "bold" }}>
                Tổng lợi nhuận:
              </Col>
              <Col span={5} style={{ fontWeight: "bold" }}>
                {(profit.plan.toLocaleString() ?? 0) + "đ"}
              </Col>
              <Col span={5} style={{ fontWeight: "bold" }}>
                {(profit.actual.toLocaleString() ?? 0) + "đ"}
              </Col>
              <Col span={5} style={{ fontWeight: "bold" }}>
                {(profit.contractor.toLocaleString() ?? 0) + "đ"}
              </Col>
            </Row>
          </Col>
          <Col span={9}>
            <Row align="middle" justify="end" style={{ height: "100%" }}>
              {dataDetail.state === "CREATED" && (
                <>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    type="primary"
                    onClick={handleCancelDetail}
                    disabled={isSavingDetail}
                    style={{ backgroundColor: "#5C5C5C" }}
                  >
                    Huỷ
                  </Button>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    type="primary"
                    style={{ marginLeft: "10px", backgroundColor: "#00529F" }}
                    onClick={() => {
                      handleSaveDetail();
                    }}
                    loading={isSavingDetail}
                    disabled={
                      !checkPermissions("BUSSINESS_PLAN", "edit", features) ||
                      isSavingDetail
                    }
                  >
                    Lưu thay đổi
                  </Button>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    type="primary"
                    style={{ marginLeft: "10px", backgroundColor: "#0082FB" }}
                    onClick={() =>
                      dataDetail.onEdit
                        ? confirm({
                            title: "Cảnh báo",
                            content:
                              "Dữ liệu chưa được lưu, bạn có muốn lưu trước khi chuyển duyệt hay không",
                            okText: "Có",
                            cancelText: "Không",
                            onCancel: () => {},
                            onOk: async () => {
                              const saved = await handleSaveDetail();
                              if (!saved) return;
                              await handleUpdateStateSheetCost(
                                dataDetail._id,
                                "submit",
                              );
                            },
                          })
                        : handleUpdateStateSheetCost(dataDetail._id, "submit")
                    }
                    disabled={
                      !checkPermissions("BUSSINESS_PLAN", "edit", features) ||
                      isSavingDetail
                    }
                  >
                    Chuyển duyệt
                  </Button>
                </>
              )}
              {(dataDetail.state === "WAITING_APPROVE_L1" ||
                dataDetail.state === "WAITING_APPROVE_L2") && (
                <>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    disabled={
                      !checkPermissions("BUSSINESS_PLAN", "reject", features)
                    }
                    type="primary"
                    onClick={() => {
                      let reason = "";
                      const inputRef = React.createRef<InputRef>();
                      confirm({
                        title: "Từ chối",
                        content: (
                          <div>
                            <Input
                              ref={inputRef}
                              value={reason}
                              onChange={(e: string) => {
                                reason = e;
                              }}
                              placeholder="Nhập lý do..."
                            />
                          </div>
                        ),
                        okText: "Có",
                        cancelText: "Không",
                        onCancel: () => {
                          reason = "";
                        },
                        onOk: () => {
                          if (!reason.trim()) {
                            message.error("Vui lòng nhập lý do");
                            return Promise.reject(
                              new Error("Reason is required"),
                            );
                          }
                          handleUpdateStateSheetCost(
                            dataDetail._id,
                            "reject",
                            reason,
                          );
                        },
                      });
                    }}
                    style={{ backgroundColor: "#F63535" }}
                  >
                    Từ chối
                  </Button>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    type="primary"
                    style={{ marginLeft: "10px", backgroundColor: "#5C5C5C" }}
                    onClick={() => {
                      let reason = "";
                      const inputRef = React.createRef<InputRef>();
                      confirm({
                        title: "Yêu cầu chỉnh sửa",
                        content: (
                          <div>
                            <Input
                              ref={inputRef}
                              value={reason}
                              onChange={(e: string) => {
                                reason = e;
                              }}
                              placeholder="Nhập lý do..."
                            />
                          </div>
                        ),
                        okText: "Có",
                        cancelText: "Không",
                        onCancel: () => {
                          reason = "";
                        },
                        onOk: () => {
                          if (!reason.trim()) {
                            message.error("Vui lòng nhập lý do");
                            return Promise.reject(
                              new Error("Reason is required"),
                            );
                          }
                          handleUpdateStateSheetCost(
                            dataDetail._id,
                            "request-edit",
                            reason,
                          );
                        },
                      });
                    }}
                    disabled={
                      !checkPermissions("BUSSINESS_PLAN", "edit", features)
                    }
                  >
                    Yêu cầu chỉnh sửa
                  </Button>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    type="primary"
                    style={{ marginLeft: "10px", backgroundColor: "#0082FB" }}
                    onClick={() =>
                      handleUpdateStateSheetCost(
                        dataDetail._id,
                        dataDetail.state === "WAITING_APPROVE_L1"
                          ? "approve-l1"
                          : "approve-l2",
                      )
                    }
                    disabled={
                      dataDetail.state === "WAITING_APPROVE_L1"
                        ? !checkPermissions(
                            "BUSSINESS_PLAN",
                            "approve",
                            features,
                          )
                        : !checkPermissions(
                            "BUSSINESS_PLAN",
                            "approve_l2",
                            features,
                          )
                    }
                  >
                    Duyệt PAKD
                  </Button>
                </>
              )}
              {dataDetail.state === "ACTIVE" && (
                <>
                  <Button
                    className={styles.ButtonFooterTableDetail}
                    type="primary"
                    onClick={() => {
                      handleUpdateStateSheetCost(dataDetail._id, "invalid");
                    }}
                    style={{ backgroundColor: "#F63535" }}
                    disabled={
                      !checkPermissions("BUSSINESS_PLAN", "invalid", features)
                    }
                  >
                    Vô hiệu PAKD
                  </Button>
                </>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    );
  };
  //Funtion to effect
  useEffect(() => {
    // CommonApi.getSearchProvine({}).then((res: any) => {
    //   setProvines(
    //     res.data?.map((ite: any) => ({ label: ite.name, value: ite._id })),
    //   );
    // });
    getPermissionDirections({}).then((res: any) => {
      setDirection(
        res?.map((ite: any) => ({ label: ite.name, value: ite.code })),
      );
    });
  }, []);
  useEffect(() => {
    let mounted = true;
    const requestId = ++listRequestIdRef.current;
    const requestMutationVersion = dataMutationVersionRef.current;
    setLoading(true);
    const fetchData = async () => {
      if (mounted) {
        const filterDate =
          filters.validFrom && filters.validFrom.length > 0
            ? {
                from: dayjs(filters.validFrom[0]).startOf("day").toISOString(),
                to: dayjs(filters.validFrom[1]).endOf("day").toISOString(),
              }
            : {};
        const resDataBusinessPlan: any =
          await BusinessPlanApi.getAllBussinessPlan({
            page: pagination.current,
            limit: pagination.pageSize,
            ...filters,
            ...filterDate,
            validFrom: undefined,
          });
        if (!mounted) return;
        if (
          !shouldApplyBusinessPlanListResponse(
            requestId,
            listRequestIdRef.current,
            requestMutationVersion,
            dataMutationVersionRef.current,
          )
        ) {
          if (requestId === listRequestIdRef.current) setLoading(false);
          return;
        }
        if (resDataBusinessPlan?.data?.length > 0) {
          const firstRow = resDataBusinessPlan?.data[0];
          handleOnEditDetail(firstRow._id, firstRow.state);
        }
        setData(resDataBusinessPlan?.data ?? []);
        setPagination((prev) => ({
          ...prev,
          total: resDataBusinessPlan?.totalItem || 0,
        }));
        setLoading(false);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [
    filters,
    activeTabs,
    pagination.current,
    pagination.pageSize,
    dataRevision,
  ]);
  useEffect(() => {
    setColumns(colsBase);
  }, [
    // provines,
    direction,
  ]);
  // if (checkPermissions("BUSSINESS_PLAN", "edit", features)) {
  utils.useBlockNavigation(isDirty);
  utils.useBeforeUnload(isDirty);
  // }
  // Main render
  return (
    <PermissionDirect screen={["BUSSINESS_PLAN"]}>
      <div className={styles.BusinessPlan}>
        {contextHolder}
        <div className="container">
          <HeaderTable
            title="Phương án kinh doanh"
            buttons={[
              {
                children: "Mẫu import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (
                    !checkPermissions(
                      "BUSSINESS_PLAN",
                      "export",
                      features,
                    )
                  ) {
                    return;
                  }
                  CommonApi.getDownloadTemplate(
                    "bussinessPlan",
                    "Phương án kinh doanh.xlsx",
                  );
                },
                type: "primary",
                disabled: !checkPermissions(
                  "BUSSINESS_PLAN",
                  "export",
                  features,
                ),
              },
              {
                children: "Cài đặt hiển thị",
                icon: <Setting />,
                onClick: () => {
                  setOnModalPosition(true);
                },
                type: "primary",
              },
              {
                children: "Thêm mới",
                icon: <PlusIcon />,
                onClick: handleAddRow,
                style: {
                  backgroundColor: checkPermissions(
                    "BUSSINESS_PLAN",
                    "add",
                    features,
                  )
                    ? "#0076E3"
                    : "#C0C0C0",
                },
                disabled: !checkPermissions("BUSSINESS_PLAN", "add", features),
              },
            ]}
          />
          <Tabs
            activeKey={activeTabs}
            items={items}
            onChange={handleBusinessPlanTabChange}
          />
          <div
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            {selectedRow?.length > 0 && (
              <Row justify="end" align="middle">
                {renderButtonApplySelect.map((btn: any, index: number) => (
                  <Button
                    key={index}
                    {...btn}
                    style={{ margin: "10px 0px 10px 10px" }}
                  />
                ))}
              </Row>
            )}
            <Table
              loading={loading}
              size="small"
              dataSource={dataSource}
              columns={renderColumns}
              scroll={{ x: "max-content" }}
              pagination={{
                ...pagination,
                onChange: (page, pageSize) => {
                  setPagination({
                    ...pagination,
                    pageSize: pageSize,
                    current: page,
                  });
                },
                showSizeChanger: true,
                pageSizeOptions: [5, 10, 15, 20, 50, 100],
              }}
              onRow={(record) => {
                return {
                  onDoubleClick: (e) => {
                    if (isLocked(detailSaveRequestKey)) return;
                    record?._id &&
                      !record?._id.includes("create") &&
                      handleOnEditDetail(record._id, record.state);
                  },
                };
              }}
              style={{ width: "100%" }} // Full theo container
              // rowSelection={rowSelected}
              rowClassName={(record: any) =>
                dataDetail?._id &&
                !dataDetail?._id.includes("create") &&
                record._id === dataDetail?._id
                  ? styles.HightLightRow
                  : ""
              }
            />
            {dataDetail && (
              <>
                <Button
                  type="primary"
                  icon={<SyncOutlined spin={true} />}
                  onClick={handleLoadingCaculator}
                  disabled={
                    !checkPermissions("BUSSINESS_PLAN", "edit", features)
                  }
                >
                  Cập nhật giá
                </Button>
                <Table
                  className={detailTableDisabledStyles.ReadableDisabledDetailTable}
                  loading={loadingDetail || isSavingDetail}
                  size="small"
                  dataSource={dataDetail?.lines ?? []}
                  rowKey={(record) => String(record.configId)}
                  columns={columnDetail}
                  scroll={{ x: "max-content", y: 500 }}
                  style={{ width: "100%" }} // Full theo container
                  pagination={false}
                  footer={() => renderFooterTableDetail()}
                  expandable={{
                    defaultExpandAllRows: true,
                  }}
                />
              </>
            )}
          </div>
        </div>
        {/* <Modal open={modalReason.open}></Modal> */}
        {renderModalPosition()}
      </div>
    </PermissionDirect>
  );
};
export { BusinessPlan };
